module.exports = "/static-assets/_next/static/images/sneaker-acbcda98ee0de415261c8027baada6ba.png";